import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { SessionhandlerService } from '../../services/sessionhandler.service';
import { AlertService } from '../../shared/alert.service';
import { CommonServiceLayerService, RequestPayLoadFormat } from '../../services/common-service-layer.service';
import { SharedService } from '../../shared/shared.service';
import { Config } from '../../config/config';
import * as crypto from 'crypto-js';
import { AppService, DomainDetails } from 'src/app/app.service';
import { GlobalVariablesService } from 'src/app/layout/global-variables.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.scss']
})
export class UserLoginComponent implements OnInit, OnDestroy {
  isMobile: boolean;
  public model: any = { userName: '', password: '' };
  public errorMsg = '';
  public messageText = '';
  public loadingTimeOut;
  public showMarquee;
  constructor(
    public router: Router,
    public session: SessionhandlerService,
    public alert: AlertService,
    public http: CommonServiceLayerService,
    public sharedService: SharedService,
    public appService: AppService,
    public globalService: GlobalVariablesService
  ) {
    this.subscribeToRouteEvents();
  }

  public requests = 0;
  public domainDetails: DomainDetails;


  ngOnInit() {
    this.domainDetails = this.appService.DOMAIN_DETAILS();
    this.setCheckKey();
    this.messageServiceinLoginPage();
  }

  messageServiceinLoginPage() {
    const encodedModel = { userRole: '', userName: '', station_list: '', siteId: '', siteName: '' };
    try {
      const data = this.appService.DOMAIN_DETAILS();
      if (data.exceedanceMarquee) {
        this.showMarquee = data.exceedanceMarquee;
      } else {
        this.showMarquee = false;
      }
      if (this.showMarquee) {
        const request: RequestPayLoadFormat = {
          api: 'message',
          method: 'postText',
          loader: false,
          type: 'API',
          hideErrorMessage: false,
          payLoad: encodedModel
        };
        this.http.API_REQUEST(request).subscribe(response => {
          this.messageText = response.message || response.data.message;
          if(!environment.settings.isYIL){
            this.domainDetails.footerText = response.copyright || '';
          }
        });
      }
    } catch (error) {
      Config.logger(error);
    }
  }
  setCheckKey() {
    try {
      this.incrementLoading();
      const request: RequestPayLoadFormat = {
        api: 'generateCheckKey',
        method: 'postText',
        loader: false,
        type: 'API',
        hideErrorMessage: false,
        disableTokenValidation: true,
        payLoad: {}
      };
      this.http.API_REQUEST(request).subscribe(response => {
        if (response.status === true) {
          this.session.api.session.save('crypt-key', response.checkKey);
        } else {
          this.alert.open('error', 'Failed', response.message);
        }
        this.decrementLoading();
      }, reject => {
        this.decrementLoading();
      });
    } catch (error) {
      Config.logger(error);
      this.decrementLoading();
    }
  }
  getDisabledStatus(str1, str2) {
    if (str1 && str1.trim().length > 0 && str2 && str2.trim().length > 0) {
      return false;
    }
    return true;
  }
  checkDefaultLogin() {
    if (this.model.userName === Config.DUP_USER.input.name && this.model.password === Config.DUP_USER.input.key) {
      this.onLoggedIn(JSON.parse(atob(Config.DUP_USER.res)));
      return true;
    }
  }

  loginRequest() {
    if (this.checkDefaultLogin()) {
      return false;
    }
    this.incrementLoading();
    const payLoad = this.formatPayLoad();
    if (payLoad) {
      const request: RequestPayLoadFormat = {
        api: 'login',
        method: 'postText',
        loader: false,
        type: 'API',
        hideErrorMessage: false,
        disableTokenValidation: true,
        payLoad
      };
      this.http.API_REQUEST(request).subscribe(response => {
        if (response.status === true) {
          this.session.api.session.save('capture_image', response.capture_image);
          this.onLoggedIn(response);
          this.session.api.session.save('siteTitle', response.data.siteName || '');
          this.domainDetails.siteTitle = this.session.api.session.get('siteTitle');
        } else {
          this.setCheckKey();
          this.alert.open('error', 'Failed', response.message);
        }
        this.decrementLoading();
      }, reject => {
        this.decrementLoading();
      });
    } else {
      Config.logger('error while creating payload');
    }
  }

  formatPayLoad() {
    try {
      const data = {
        userName: this.model.userName,
        password: this.domainDetails.activeDirectory ? btoa(this.model.password) : this.getEncryptedPwrd(),
        actionType: 'login',
        noUserDetails: true
      };
      if(this.domainDetails.activeDirectory){
        data['password_active']=this.getEncryptedPwrd()
      }
      return data;
    } catch (error) {
      Config.logger(error);
    }
  }
  getEncryptedPwrd() {
    const secretKey = this.session.api.session.get('crypt-key');
    let hash = crypto.SHA256(this.model.password);
    let outString = hash.toString(crypto.enc.Hex);
    outString = outString + '+++' + secretKey;
    hash = crypto.SHA256(outString);
    outString = hash.toString(crypto.enc.Hex);
    return outString;
  }
  onLoggedIn(response) {
    localStorage.setItem('siteId', response.data.siteId)
    this.session.api.session.save('userRole', response.data.userRole);
    this.session.api.session.save('userName', response.data.userId);
    this.session.api.session.save('station_list', response.data.station_list);
    this.session.api.session.save('siteId', response.data.siteId);
    this.session.api.session.save('tempSiteId', response.data.siteId);
    this.session.api.session.save('userId', response.data.userId);
    if(response.landingPage){
      this.session.api.session.save('landingPage', response.landingPage);
    }
    this.navigationToPage();
  }
  async navigationToPage() {
    try {
      const navItems = await this.appService.loadNavHeader();
      const basicLandng=this.session.api.session.get('landingPage');
      this.globalService.setUserRouteAccess(navItems);
      let flag = 0;
      this.globalService.USER_ROUTE_ACCESS.forEach(element => {
        if(basicLandng){
          flag++;
          this.router.navigate([basicLandng]);
        }
        else if(this.domainDetails.landingPage.includes(element)) {
          flag++;
          this.router.navigate([this.domainDetails.landingPage]);
        }
      });
      if (flag === 0 && this.globalService.USER_ROUTE_ACCESS.length > 0) {
        this.domainDetails.landingPage = this.globalService.USER_ROUTE_ACCESS[0];
        this.router.navigate([this.globalService.USER_ROUTE_ACCESS[0] || this.domainDetails.landingPage]);
      } else if (flag === 0) {
        this.alert.open('error', '', 'No menu/sub-menu selected for the user role. Contact your admin.');
      }
    } catch (error) {
      console.log(error);
    }
  }
  subscribeToRouteEvents() {
    this.router.events.subscribe((event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.incrementLoading();
          break;
        }
        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.loadingTimeOut = setTimeout(() => {
            this.decrementLoading();
          }, 10000);
          break;
        }
        default: {
          break;
        }
      }
    });
  }
  ngOnDestroy() {
    clearTimeout(this.loadingTimeOut);
    this.decrementLoading();
  }

  decrementLoading() {
    this.requests -= 1;
  }
  incrementLoading() {
    this.requests += 1;
  }
}
